<template>
	<div>
		<RangeDropdown
			v-model="localValue"
			:options="options"
			suffix="Stunden pro Woche"
			@input="emitChangeEvent"
		/>
	</div>
</template>

<script>
import RangeDropdown from "@/vue/common/RangeDropdown.vue";
import _ from "lodash";

export default {

	components: {
		RangeDropdown,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	mounted ()
	{
		this.emitChangeEvent();
	},

	data ()
	{
		let localValue = {
			min: 20,
			max: 30
		};

		if (this.value)
		{
			localValue = this.value;
		}

		let options = [];

		_.range(1, 45, 1).forEach(month =>
		{
			options.push({
				value: month,
				text: month
			});

			// TODO not possible until max is float in database and solr
			// if (month === 38)
			// {
			// 	options.push({
			// 		value: 38.5,
			// 		text: '38,5'
			// 	});
			// }
		});

		return {
			localValue,
			options
		};
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', this.localValue);
		},
	}
}
</script>
